import { LoginCallback } from "@okta/okta-react";

export const Callback = LoginCallback;
